import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Mail, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bg">
        <div className="bg-grid-footer"></div>
        <div className="footer-glow"></div>
      </div>
      
      <div className="container">
        <div className="footer-content">
          {/* Main Footer */}
          <div className="footer-main">
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <div className="logo-icon">
                  <img src="/logo.png" alt="TRCKLST" className="logo-image" />
                </div>
                <span className="logo-text">TRCKLST</span>
              </Link>
              <p className="footer-description">
                Your destination for high-quality digital music posters. 
                Discover, purchase, and print artwork from talented artists worldwide.
              </p>
              <div className="social-links">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <a href="mailto:hello@trcklst.com" className="social-link" aria-label="Email">
                  <Mail size={20} />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <div className="link-group">
                <h3 className="link-group-title">Shop</h3>
                <ul className="link-list">
                  <li><Link to="/shop" className="footer-link">All Posters</Link></li>
                  <li><Link to="/shop?type=digital" className="footer-link">Digital Downloads</Link></li>
                  <li><Link to="/shop?sort=newest" className="footer-link">New Releases</Link></li>
                </ul>
              </div>

              <div className="link-group">
                <h3 className="link-group-title">Account</h3>
                <ul className="link-list">
                  <li><Link to="/profile" className="footer-link">My Account</Link></li>
                  <li><Link to="/profile" className="footer-link">Order History</Link></li>
                  <li><Link to="/cart" className="footer-link">Shopping Cart</Link></li>
                </ul>
              </div>

              <div className="link-group">
                <h3 className="link-group-title">Support</h3>
                <ul className="link-list">
                  <li><a href="mailto:hello@trcklst.com" className="footer-link">Contact Us</a></li>
                  <li><a href="#" className="footer-link">FAQs</a></li>
                  <li><a href="#" className="footer-link">How It Works</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <div className="contact-item">
              <MapPin size={16} />
              <span>Toronto, ON</span>
            </div>
            <div className="contact-item">
              <Mail size={16} />
              <span>hello@trcklst.com</span>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <p className="copyright">
                © 2025 TRCKLST. All rights reserved.
              </p>
            </div>
            <div className="footer-bottom-right">
              <a href="#" className="footer-legal-link">Privacy Policy</a>
              <a href="#" className="footer-legal-link">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;